import * as React from "react";
import { Link } from "react-router-dom";

export const OccupancyOverviewHeader: React.FC = () => (
  <div className="wrap">
    <div className="intro intro--stats">
      <Link to="/statistics" className="link link--icon link--arrow-left">
        Back
      </Link>
      <h1 className="intro__title">
        Statistics by <span className="intro__title-highlight">Occupancy</span>
      </h1>
    </div>
  </div>
);
